export default "__VITE_ASSET__b7c4e7f1__"